import { useState, useEffect, useCallback } from 'react';
import { api } from '../services/api';

/**
 * ZYN-53 — Hook compartilhado para o widget de meta.
 * Sidebar (mini widget) e DashboardPage (card expandido) consomem sem requests duplicados
 * porque ambos chamam o hook com a mesma chave de cache (singleton simples por tab).
 */

let cache = null;
let cacheTs = 0;
const CACHE_TTL = 60_000; // 1 min

export function useMyProgress() {
  const [progress, setProgress] = useState(cache ?? []);
  const [loading, setLoading]   = useState(!cache);

  const load = useCallback(async () => {
    const now = Date.now();
    if (cache && now - cacheTs < CACHE_TTL) {
      setProgress(cache);
      setLoading(false);
      return;
    }
    try {
      // request() resolve com undefined em 401 (redirect p/ login em andamento) —
      // sem o guard, progress=undefined crasha Sidebar/Dashboard (CRM-TOTVS-MODA-CLIENT-9)
      const data = await api.getMyProgress();
      const list = Array.isArray(data) ? data : [];
      cache   = list;
      cacheTs = Date.now();
      setProgress(list);
    } catch {
      setProgress([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { progress, loading };
}
